export default __webpack_public_path__ + "static/media/task-app.66811240.jpeg";